<template>
  <div>
    <ContactBanner
      :imageList="this.config.banner_top.imageList"
    ></ContactBanner>
    <ContactTitle1></ContactTitle1>
    <JoinContent></JoinContent>
    <ContactTitle2></ContactTitle2>
    <ContactContent></ContactContent>
    <ContactBottom></ContactBottom>
    <ContactBanner3></ContactBanner3>
  </div>
</template>

<script>
import ContactBanner from "@/yintai/view/content/contact/ContactBanner.vue";
import ContactTitle1 from "@/yintai/view/content/contact/ContactTitle1.vue";
import ContactTitle2 from "@/yintai/view/content/contact/ContactTitle2.vue";
import ContactContent from "@/yintai/view/content/contact/ContactContent.vue";
import JoinContent from "@/yintai/view/content/contact/JoinContent.vue";
import ContactBottom from "@/yintai/view/content/contact/ContactBottom.vue";

import ContactBanner3 from "@/yintai/view/content/contact/ContactBanner3.vue";
import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "contact",
  components: {
    ContactBanner,
    ContactTitle1,
    ContactTitle2,
    ContactContent,
    ContactBanner3,
    ContactBottom,
    JoinContent,
  },

  metaInfo() {
    return {
      meta: [{name: "keywords" ,content:"银泰百货校招,银泰百货校园招聘,银泰招聘,银泰百货招聘"},{name: "description" ,content:"银泰招聘面向全社会优秀人才，覆盖全国24个城市，银泰百货招聘对象同时面向全国各大高校毕业生校园招聘。欢迎联系银泰百货，一起打造新零售。"}],
      title: "银泰百货-银泰招聘-联系我们"
    };
  },

  data() {
    return {
      config: {
        banner_top: {
          imageList: [],
        },
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 7 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
